import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import Lightbulb from '../../assets/images/Lightbulb.png'

function TipCard({ isMobile }) {
  const messages = [
    'Start with your résumé upload — it unlocks your first Skill Match Score and makes your job matches even smarter.',
    'Keep your profile up to date to improve your Skill Match Scores.',
    'Explore job opportunities regularly to stay ahead in high-demand fields.',
  ];

  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true); // fade in/out

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // start fade out
      setTimeout(() => {
        setIndex((prev) => (prev + 1) % messages.length); // next message
        setFade(true); // fade in
      }, 500); // fade duration
    }, 5000); // change every 5s

    return () => clearInterval(interval);
  }, []);

  return (
    <Card
      sx={{
        maxWidth: isMobile ? 350 : 600,
        width: '100%',
        borderRadius: 6,
        backgroundColor: '#efe5f9',
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center'}}>
        <img src={Lightbulb} alt="Lightbulb" width={isMobile ? 40 : 60} height={isMobile ? 40 : 60} style={{ marginRight: isMobile ? 8 : 16 }} />
        <Box
          sx={{
            transition: 'opacity 0.5s',
            opacity: fade ? 1 : 0,
          }}
        >
          <Typography variant="body1" sx={{ fontSize: isMobile ? '0.95rem' : '1rem' }}>
            {messages[index]}
          </Typography>
        </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default TipCard;
